import { render, staticRenderFns } from "./mrc_ess_viewbtn.vue?vue&type=template&id=2b5bc4eb&scoped=true&"
import script from "./mrc_ess_viewbtn.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_viewbtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bc4eb",
  null
  
)

export default component.exports